import React from 'react';

const SomethingWrong = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/something_went_wrong.png"} width="300" />
    </div>;
}

export default SomethingWrong;